import templateUrl from './preview-signature-owner-modal.component.html'

export const PreviewSignatureOwnerModalComponent = {
    templateUrl,
    controller: PreviewSignatureOwnerController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


function PreviewSignatureOwnerController($scope, $sce) {
    'ngInject';
    const vm = this;
    vm.pdfUrl;
    vm.submit = submit;
    vm.drawing = drawing;
    vm.allowApprove = false;
    vm.allowSign = false;
    vm.sign;
    vm.boundingBox = {
        width: 700,
        height: 300,
    };

    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.allowApprove = vm.resolve.allowApprove;
        vm.allowSign = vm.resolve.allowSign;
        vm.pdfUrl = $sce.trustAsResourceUrl(vm.resolve.previewUrl + "#zoom=FitH");
    }

    function drawing(draw) {
        if (!draw) {
            vm.sign = $scope.accept();
        }
    }

    
    function submit() {
        if (vm.sign && vm.sign.isEmpty && vm.allowSign) {
            alert("Signature is required!");
        } else {
            let result = {
                dataUrl: vm.sign.dataUrl,
                sign: "yolo" // set other variables
            }
            vm.close({ $value: result });
        }
    }
}

export const PreviewSignatureOwnerModal = {
    component: "apexPreviewSignatureOwnerModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
